import React, { useEffect, useState } from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';
import EfVideo from '@elem/ui/ef-video';
import { useRouter } from 'next/router';
// import EFLight from './icons/EFLight';
// import EFThermostats from './icons/EFThemostats';
// import EFPlus from './icons/EFPlus';
// import EFWave from './icons/EFWave';
// import EFGlacier from './icons/EFGlacier';

// type BoxItemType = {
//     icon: JSX.Element;
//     text: string;
// };

type ImgItemType = {
    img: string;
    text: string;
};

const D: React.FC = () => {
    const { t } = useLang('Oasis');
    const [enter, setEnter] = useState<number>(2);
    const [video, setVideo] = useState<string[]>(['', '']);
    const { locale = 'us' } = useRouter();
    const box1Video: {
        [key: string]: any;
    } = {
        us: [
            'https://websiteoss.ecoflow.com/upload/video/1735783567249/D.mp4',
            'https://websiteoss.ecoflow.com/upload/video/1735783567249/D.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1735783766873/D.jpg',
        ],
        ca: [
            'https://websiteoss.ecoflow.com/upload/video/1735783567249/D.mp4',
            'https://websiteoss.ecoflow.com/upload/video/1735783567249/D.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1735783766873/D.jpg',
        ],
        eu: [
            'https://websiteoss.ecoflow.com/upload/video/1744356952732/%E5%BC%80%E5%8F%91-monitor-device_%E5%8D%95%E6%89%8B%E6%9C%BA-EU-eu.mp4',
            'https://websiteoss.ecoflow.com/upload/video/1744356952732/%E5%BC%80%E5%8F%91-monitor-device_%E5%8D%95%E6%89%8B%E6%9C%BA-EU-eu.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1744356952549/%E5%BC%80%E5%8F%91-monitor-device_%E5%8D%95%E6%89%8B%E6%9C%BA-EU-eu.jpg',
        ],
        nl: [
            'https://websiteoss.ecoflow.com/upload/video/1744356952732/%E5%BC%80%E5%8F%91-monitor-device_%E5%8D%95%E6%89%8B%E6%9C%BA-EU-eu.mp4',
            'https://websiteoss.ecoflow.com/upload/video/1744356952732/%E5%BC%80%E5%8F%91-monitor-device_%E5%8D%95%E6%89%8B%E6%9C%BA-EU-eu.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1744356952549/%E5%BC%80%E5%8F%91-monitor-device_%E5%8D%95%E6%89%8B%E6%9C%BA-EU-eu.jpg',
        ],
        uk: [
            'https://websiteoss.ecoflow.com/upload/video/1744357217157/%E5%BC%80%E5%8F%91-monitor-device_%E5%8D%95%E6%89%8B%E6%9C%BA-EU-uk.mp4',
            'https://websiteoss.ecoflow.com/upload/video/1744357217157/%E5%BC%80%E5%8F%91-monitor-device_%E5%8D%95%E6%89%8B%E6%9C%BA-EU-uk.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1744357217019/%E5%BC%80%E5%8F%91-monitor-device_%E5%8D%95%E6%89%8B%E6%9C%BA-EU-uk.jpg',
        ],
        de: [
            'https://websiteoss.ecoflow.com/upload/video/1744357244907/%E5%BC%80%E5%8F%91-monitor-device_%E5%8D%95%E6%89%8B%E6%9C%BA-EU-de.mp4',
            'https://websiteoss.ecoflow.com/upload/video/1744357244907/%E5%BC%80%E5%8F%91-monitor-device_%E5%8D%95%E6%89%8B%E6%9C%BA-EU-de.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1744357244758/%E5%BC%80%E5%8F%91-monitor-device_%E5%8D%95%E6%89%8B%E6%9C%BA-EU-de.jpg',
        ],
        fr: [
            'https://websiteoss.ecoflow.com/upload/video/1744357269446/%E5%BC%80%E5%8F%91-monitor-device_%E5%8D%95%E6%89%8B%E6%9C%BA-EU-fr.mp4',
            'https://websiteoss.ecoflow.com/upload/video/1744357269446/%E5%BC%80%E5%8F%91-monitor-device_%E5%8D%95%E6%89%8B%E6%9C%BA-EU-fr.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1744357269293/%E5%BC%80%E5%8F%91-monitor-device_%E5%8D%95%E6%89%8B%E6%9C%BA-EU-fr.jpg',
        ],
        it: [
            'https://websiteoss.ecoflow.com/upload/video/1744356952732/%E5%BC%80%E5%8F%91-monitor-device_%E5%8D%95%E6%89%8B%E6%9C%BA-EU-eu.mp4',
            'https://websiteoss.ecoflow.com/upload/video/1744356952732/%E5%BC%80%E5%8F%91-monitor-device_%E5%8D%95%E6%89%8B%E6%9C%BA-EU-eu.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1744356952549/%E5%BC%80%E5%8F%91-monitor-device_%E5%8D%95%E6%89%8B%E6%9C%BA-EU-eu.jpg',
        ],
        es: [
            'https://websiteoss.ecoflow.com/upload/video/1744356952732/%E5%BC%80%E5%8F%91-monitor-device_%E5%8D%95%E6%89%8B%E6%9C%BA-EU-eu.mp4',
            'https://websiteoss.ecoflow.com/upload/video/1744356952732/%E5%BC%80%E5%8F%91-monitor-device_%E5%8D%95%E6%89%8B%E6%9C%BA-EU-eu.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1744356952549/%E5%BC%80%E5%8F%91-monitor-device_%E5%8D%95%E6%89%8B%E6%9C%BA-EU-eu.jpg',
        ],
    };
    const box2Img: {
        [key: string]: any;
    } = {
        us: [
            'https://websiteoss.ecoflow.com/upload/image/1735642044892/D1.png',
            'https://websiteoss.ecoflow.com/upload/image/1735642032219/D2.png',
            'https://websiteoss.ecoflow.com/upload/image/1736230405089/D3.png',
            'https://websiteoss.ecoflow.com/upload/image/1735642045066/D4.png',
            'https://websiteoss.ecoflow.com/upload/image/1735642031847/D5.png',
        ],
        ca: [
            'https://websiteoss.ecoflow.com/upload/image/1735642044892/D1.png',
            'https://websiteoss.ecoflow.com/upload/image/1735642032219/D2.png',
            'https://websiteoss.ecoflow.com/upload/image/1736230405089/D3.png',
            'https://websiteoss.ecoflow.com/upload/image/1735642045066/D4.png',
            'https://websiteoss.ecoflow.com/upload/image/1735642031847/D5.png',
        ],
        eu: [
            'https://websiteoss.ecoflow.com/upload/image/1744459058955/1.png',
            'https://websiteoss.ecoflow.com/upload/image/1744459059140/2.png',
            'https://websiteoss.ecoflow.com/upload/image/1744459059361/3.png',
            'https://websiteoss.ecoflow.com/upload/image/1744459059573/4.png',
            'https://websiteoss.ecoflow.com/upload/image/1744459059781/5.png',
        ],
        nl: [
            'https://websiteoss.ecoflow.com/upload/image/1744459058955/1.png',
            'https://websiteoss.ecoflow.com/upload/image/1744459059140/2.png',
            'https://websiteoss.ecoflow.com/upload/image/1744459059361/3.png',
            'https://websiteoss.ecoflow.com/upload/image/1744459059573/4.png',
            'https://websiteoss.ecoflow.com/upload/image/1744459059781/5.png',
        ],
        uk: [
            'https://websiteoss.ecoflow.com/upload/image/1744459124190/1.png',
            'https://websiteoss.ecoflow.com/upload/image/1744459124343/2.png',
            'https://websiteoss.ecoflow.com/upload/image/1744459124538/3.png',
            'https://websiteoss.ecoflow.com/upload/image/1744459124745/4.png',
            'https://websiteoss.ecoflow.com/upload/image/1744459124929/5.png',
        ],
        de: [
            'https://websiteoss.ecoflow.com/upload/image/1744369871605/1.png',
            'https://websiteoss.ecoflow.com/upload/image/1744369871799/2.png',
            'https://websiteoss.ecoflow.com/upload/image/1744369872400/3.png',
            'https://websiteoss.ecoflow.com/upload/image/1744369872195/4.png',
            'https://websiteoss.ecoflow.com/upload/image/1744369871977/5.png',
        ],
        fr: [
            'https://websiteoss.ecoflow.com/upload/image/1744371096232/1.png',
            'https://websiteoss.ecoflow.com/upload/image/1744371096790/2.png',
            'https://websiteoss.ecoflow.com/upload/image/1744371298361/20250411-193251.png',
            'https://websiteoss.ecoflow.com/upload/image/1744371096412/4.png',
            'https://websiteoss.ecoflow.com/upload/image/1744371096602/5.png',
        ],
        it: [
            'https://websiteoss.ecoflow.com/upload/image/1744459058955/1.png',
            'https://websiteoss.ecoflow.com/upload/image/1744459059140/2.png',
            'https://websiteoss.ecoflow.com/upload/image/1744459059361/3.png',
            'https://websiteoss.ecoflow.com/upload/image/1744459059573/4.png',
            'https://websiteoss.ecoflow.com/upload/image/1744459059781/5.png',
        ],
        es: [
            'https://websiteoss.ecoflow.com/upload/image/1744459058955/1.png',
            'https://websiteoss.ecoflow.com/upload/image/1744459059140/2.png',
            'https://websiteoss.ecoflow.com/upload/image/1744459059361/3.png',
            'https://websiteoss.ecoflow.com/upload/image/1744459059573/4.png',
            'https://websiteoss.ecoflow.com/upload/image/1744459059781/5.png',
        ],
    };
    const box2Items: ImgItemType[] = [
        {
            img: box2Img[locale][0],
            text: t('D_box2_text1'),
        },
        {
            img: box2Img[locale][1],
            text: t('D_box2_text2'),
        },
        {
            img: box2Img[locale][2],
            text: t('D_box2_text3'),
        },
        {
            img: box2Img[locale][3],
            text: t('D_box2_text4'),
        },
        {
            img: box2Img[locale][4],
            text: t('D_box2_text5'),
        },
    ];

    const handleVideoPlay = (cls: string) => {
        const IS_PC = window?.innerWidth > 1024;
        const video: HTMLVideoElement | null = document.querySelector(`.page-oasis-D .${cls} .ef-video-item-${IS_PC ? 'pc' : 'h5'}`);
        if (video) {
            video.currentTime = 0;
            video.play();
        }
    };

    useEffect(() => {
        // 其实也可以写成AniContainer
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting && entry.target.classList[0] === 'page-oasis-C' && video?.some((v: string) => !v)) {
                    // 进入C模块时加载第一个视频
                    setVideo(box1Video[locale]);
                }
            });
        });

        const sectionC: HTMLDivElement | null = document.querySelector('.page-oasis-C');
        if (sectionC) {
            observer.observe(sectionC);
        }
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const container = '.page-oasis-D';
            const IS_PC = window?.innerWidth > 1024;
            // 进入开始播放视频
            const video1 = document.querySelector('.page-oasis-D .box1 .video-box') as HTMLDivElement;
            const playVideo = AniContainer.create({
                triggerElement: '.page-oasis-D .box1 .video-box',
                triggerHook: 1,
                offset: IS_PC ? '50%' : video1?.offsetHeight / 2,
                duration: IS_PC ? '100%' : '50%',
                onEnter: () => handleVideoPlay('box1'),
            });
            if (IS_PC) {
                // => 仅PC端
                // 滚动条控制动画
                const scroll = AniContainer.create({
                    asyncFromTo: [
                        ['.page-oasis-D .box1 .video-box', { opacity: 0 }, { opacity: 1 }, 0.001], // box1 视频秒现
                        ['.page-oasis-D .box1 .info .inner', { opacity: 0 }, { opacity: 1 }, 0.2], // box1 文案渐显
                        ['.page-oasis-D .box1 .info .inner', { opacity: 1 }, { opacity: 1 }, 0.6], // box1 文案维持
                        ['.page-oasis-D .box1 .info .inner', { opacity: 1, y: 0 }, { opacity: 0, y: -120 }, 0.2], // box1 文案渐隐
                        ['.page-oasis-D .box1 .video-box', { opacity: 1 }, { opacity: 0 }, 0.001], // box1 视频秒隐

                        ['.page-oasis-D .box2 .items', { opacity: 0 }, { opacity: 1 }, 0.001], // box4 图片秒现
                        // ['.page-oasis-D .box2 .items .item-2 .item-inner', { y: 0 }, { y: -60 }, 0.25], // box4 item-2 上移
                        // ['.page-oasis-D .box2 .items .item-4 .item-inner', { y: 0 }, { y: -60 }, 0.25], // box4 item-4 上移
                        ['.page-oasis-D .box2 .info', { opacity: 1 }, { opacity: 1 }, 1], // box4 维持
                    ],
                    asyncTimeLine: [
                        0, 0.5, 0.7, 1.3, 1.499,
                        // 1 - 2
                        // 1.449, 1.75, 1.75, 2.5,
                        1.449, 2.5,
                    ],
                    triggerElement: container,
                    triggerHook: 1,
                    offset: 0,
                    duration: '350%',
                });
                // enter1和enter2
                const enter1 = AniContainer.create({
                    triggerElement: '.page-oasis-D .box1',
                    triggerHook: 1,
                    offset: 0,
                    duration: '150%',
                    onEnter: () => {
                        setEnter(1);
                        const aniImg: HTMLDivElement | null = document.querySelector('.page-oasis-D .box1 .ani-img');
                        if (aniImg) {
                            const styleObj = {
                                '1920': {
                                    bottom: '0%',
                                    left: '18.75%',
                                },
                                '1366': {
                                    bottom: '0%',
                                    left: '18.75%',
                                },
                            };
                            const screenWidth = window?.innerWidth > 1440 ? '1920' : '1366';
                            const curStyle = styleObj[screenWidth];
                            aniImg.style.bottom = curStyle.bottom;
                            aniImg.style.left = curStyle.left;
                            aniImg.style.opacity = '0';
                        }
                    },
                });
                // box2 小图片位移+缩放+box4图片展开
                const enter2 = AniContainer.create({
                    triggerElement: '.page-oasis-D .box2',
                    triggerHook: 1,
                    offset: '150%',
                    duration: '200%',
                    onEnter: () => {
                        setEnter(2);
                        const timer = setInterval(() => {
                            const img3: HTMLLIElement | null = document.querySelector('.page-oasis-D .box2 .item-3');
                            const aniImg: HTMLDivElement | null = document.querySelector('.page-oasis-D .box1 .ani-img');
                            if (img3 && aniImg) {
                                const { offsetTop, offsetLeft } = img3;
                                aniImg.style.top = `${offsetTop}px`;
                                aniImg.style.left = `${offsetLeft}px`;
                                aniImg.style.opacity = '1';
                                clearInterval(timer);
                            }
                        }, 100);
                    },
                });

                return () => {
                    const sceneArr = [scroll, enter1, enter2];
                    sceneArr.forEach((scene) => scene.destroy());
                };
            }
            if (!IS_PC) {
                const box2Lists: HTMLUListElement | null = document.querySelector('.page-oasis-D .box2 .items');
                const box2Item: HTMLUListElement | null = document.querySelector('.page-oasis-D .box2 .items .item');
                const winH = window.innerHeight;
                const winW = window.innerWidth;
                const box2ItemsScroll = AniContainer.create({
                    asyncFromTo: [
                        [
                            box2Lists,
                            { x: (winW - Number(box2Item?.offsetWidth)) / 2 },
                            { x: winW / 2 - Number(box2Lists?.offsetWidth) + Number(box2Item?.offsetWidth) / 2 },
                            8,
                        ],

                        ['.page-oasis-D .box2 .items .item-1 .item-text', { opacity: 1 }, { opacity: 1 }, 0.25],
                        ['.page-oasis-D .box2 .items .item-1 .item-text', { opacity: 1 }, { opacity: 0 }, 0.25],
                        ['.page-oasis-D .box2 .items .item-1 .ef-img', { scale: 1.4 }, { scale: 1 }, 1],

                        ['.page-oasis-D .box2 .items .item-2 .ef-img', { scale: 1 }, { scale: 1.4 }, 1.75],
                        ['.page-oasis-D .box2 .items .item-2 .item-text', { opacity: 0 }, { opacity: 1 }, 0.25],
                        ['.page-oasis-D .box2 .items .item-2 .item-text', { opacity: 1 }, { opacity: 0 }, 0.25],
                        ['.page-oasis-D .box2 .items .item-2 .ef-img', { scale: 1.4 }, { scale: 1 }, 1.75],

                        ['.page-oasis-D .box2 .items .item-3 .ef-img', { scale: 1 }, { scale: 1.4 }, 2],
                        ['.page-oasis-D .box2 .items .item-3 .item-text', { opacity: 0 }, { opacity: 1 }, 0.25],
                        ['.page-oasis-D .box2 .items .item-3 .item-text', { opacity: 1 }, { opacity: 0 }, 0.25],
                        ['.page-oasis-D .box2 .items .item-3 .ef-img', { scale: 1.4 }, { scale: 1 }, 2],

                        ['.page-oasis-D .box2 .items .item-4 .ef-img', { scale: 1 }, { scale: 1.4 }, 2],
                        ['.page-oasis-D .box2 .items .item-4 .item-text', { opacity: 0 }, { opacity: 1 }, 0.25],
                        ['.page-oasis-D .box2 .items .item-4 .item-text', { opacity: 1 }, { opacity: 0 }, 0.25],
                        ['.page-oasis-D .box2 .items .item-4 .ef-img', { scale: 1.4 }, { scale: 1 }, 1.75],

                        ['.page-oasis-D .box2 .items .item-5 .ef-img', { scale: 1 }, { scale: 1.4 }, 1],
                        ['.page-oasis-D .box2 .items .item-5 .item-text', { opacity: 0 }, { opacity: 1 }, 0.25],
                    ],
                    asyncTimeLine: [
                        // 8份=> 1 : 2 : 2 : 2 : 1
                        0,
                        // 1份
                        0, 0.5, 0,
                        // 2份
                        0.5, 1.25, 2.5, 2.25,
                        // 2份
                        2, 3.5, 4.5, 4,
                        // 2份
                        4, 4.5, 6, 5.75,
                        // 1份
                        6.5, 6.75,
                    ],
                    triggerElement: '.page-oasis-D .box2 .items-box',
                    triggerHook: 1,
                    duration: winH,
                    offset: '100%',
                });
                return () => {
                    box2ItemsScroll.destroy();
                };
            }
            return () => {
                const sceneArr = [playVideo];
                sceneArr.forEach((scene) => scene.destroy());
            };
        }
    }, []);

    return (
        <div className={`page-oasis-D ${css.section}`} id="page-oasis-D">
            <div className="sticky">
                <div className={`box box1 ${enter === 1 ? 'enter' : ''} ${enter === 2 ? 'enterBox2' : ''}`}>
                    <div className="info">
                        <div className="inner">
                            <p className="title s">{t(`D_box1_title`)}</p>
                            <p className="desc s">
                                {t.rich(`D_box1_desc`, {
                                    w: (tx: string) => <span className="w">{tx}</span>,
                                    sup: (tx: string) => <sup>{tx}</sup>,
                                })}
                            </p>
                            {/* <ul className="items">
                                {box1Items.map((item: BoxItemType, k) => (
                                    <li className="item" key={k}>
                                        {item.icon}
                                        <p className="item-text">{item.text}</p>
                                    </li>
                                ))}
                            </ul> */}
                            {/* <p className="tip">{t('D_box1_tip')}</p> */}
                        </div>
                    </div>
                    <div className="video-box">{(video[0] || video[1]) && <EfVideo pc={video[0]} h5={video[1]} poster={video[2]} preload="none" />}</div>
                    <div className="ani-img">
                        <div className="ani-box ani-1">{video[2] && <EfImg pc={video[2]} />}</div>
                        <div className="ani-box ani-2">
                            <EfImg pc={box2Items[2].img} />
                        </div>
                        <div className="ani-box ani-3">
                            <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1735624886947/D_small.png" />
                        </div>
                    </div>
                </div>
                <div className={`box box2 ${enter === 2 ? 'enter' : ''} ${enter === 2 ? 'enterBox2' : ''}`}>
                    <div className="info">
                        <div className="inner">
                            <p className="title s">{t(`D_box2_title`)}</p>
                            <p className="desc s">
                                {t.rich(`D_box2_desc`, {
                                    w: (tx: string) => <span className="w">{tx}</span>,
                                })}
                            </p>
                        </div>
                        <div className="items-sticky">
                            <div className="items-box">
                                <ul className="items">
                                    {box2Items.map((item, k) => (
                                        <li className={`item item-${k + 1}`} key={k}>
                                            <div className={`item-inner item-inner-${k}`}>
                                                <div className="item-img">
                                                    <EfImg pc={item.img} />
                                                </div>
                                                <p className="item-text">{item.text}</p>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default D;
